// Auto-generated by scripts/wheel.js — do not edit manually
import img0 from './food.png';
import img1 from './money.png';
import img2 from './event.png';
import img3 from './dinner-jeroen.png';
import img4 from './dinner.png';
import img5 from './champagne.png';
import img6 from './lottery.png';
const images = {
  'food.png': img0,
  'money.png': img1,
  'event.png': img2,
  'dinner-jeroen.png': img3,
  'dinner.png': img4,
  'champagne.png': img5,
  'lottery.png': img6,
};
export default images;
